export default __webpack_public_path__ + "static/media/sunlife-logo.8d1867ca.png";